export const TOAST_MESSAGES = {
  COPIED_TO_CLIPBOARD: "Copied to clipboard",
  ASSISTANT_UPDATED: "Assistant updated",
  PHONE_NUMBER_ATTACHED: "Phone number attached",
  PHONE_NUMBER_DETACHED: "Phone number detached",
  ASSISTANT_CREATED: "Assistant created",
  ASSISTANT_DELETED: "Assistant deleted",
  CHANGES_SAVED: "Changes saved",
  ERROR_SAVING_CHANGES: "Error saving changes",
  KNOWLEDGE_BASE_ATTACHED: "Knowledge base attached",
  KNOWLEDGE_BASE_DETACHED: "Knowledge base detached",
  KNOWLEDGE_BASE_CREATED: "Knowledge base created",
  KNOWLEDGE_BASE_DELETED: "Knowledge base deleted",
  KNOWLEDGE_BASE_UPDATED: "Knowledge base updated",
  CALLER_ID_ATTACHED: "Caller Id attached",
  CALLER_ID_DETACHED: "Caller Id detached",
  ACTION_CREATED: "Action created",
  ACTION_UPDATED: "Action updated",
  ACTION_DELETED: "Action deleted",
  PHONE_NUMBER_VERIFIED: "Phone number is verified",
  PHONE_NUMBER_VERIFICATION_FAILED: "Phone number verification failed",
};
